export class WaitingListItemObject {
    constructor(date, startTime, endTime) {
        this.date = date;
        this.start_time = startTime;
        this.end_time = endTime;
    }

    toObject() {
        return {
            date: this.date,
            start_time: this.start_time,
            end_time: this.end_time
        }
    }

}
